export enum Sort {
    trustScore = "trustScore",
    volume = "volume24h",
    transactions24h = "transactions24h",
}

interface IDyorJetton {
    rawAddress: string;
    score: number;
    friendlyAddress: string;
    address: string;
    name: string;
    symbol: string;
    decimals: number;
    image: string;
    description: string;
}

interface IDyorBestTokensResponse {
    cursor: string | null;
    items: IDyorJetton[];
    updatedAt: number;
}

export class DyorApi {
    private static basePath = "https://api.dyor.io/v1";
    private static cacheKey = "bestTokensCache";

    private static cursor: string | null = null;
    private static lastCallTime: number = 0;

    static async getBestTokens(
        ///ЧИТАТЬ КОММЕНТ!
        //Эта тема получает токены из API и кеширует их в localStorage, можно просортировать по енаму Sort.
        //force = тру, тогда локальное хранилище посылается нахуй и мы получаем токены по следующему курсору.
        //ждет глобальную задержку в одну секунду чтобы не спамить
        sort: Sort = Sort.volume,
        limit: number = 1000,
        force?: boolean,
    ): Promise<IDyorBestTokensResponse> {
        try {
            let urlString = `${DyorApi.basePath}/jettons`;
            let url = new URL(urlString);

            if (this.cursor) {
                url.searchParams.append("cursor", this.cursor);
            }

            url.searchParams.append("sort", sort);
            url.searchParams.append("order", "desc");
            url.searchParams.append("limit", limit.toString());
            url.searchParams.append("excludeScam", "true");

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch best tokens");
            }

            const data = await response.json();
            const buildResponse = (data: any) => {
                const result: IDyorJetton[] = [];

                data.jettons.forEach((item: any) => {
                    if (
                        item.metadata.address !== "0:0000000000000000000000000000000000000000000000000000000000000000"
                    ) {
                        result.push({
                            ...item,
                            rawAddress: item.metadata.address,
                            score: item.trustScore,
                            friendlyAddress: data.addressBook[item.metadata.address]?.userFriendly,
                            jettonMasterAddress: data.addressBook[item.metadata.address]?.userFriendly,
                        });
                    }
                });

                let isItFirstRequest = this.cursor === null;

                this.cursor = data.next;

                const responseWithTimestamp: IDyorBestTokensResponse = {
                    cursor: data.next,
                    items: result,
                    updatedAt: Date.now(),
                };
                if (isItFirstRequest) {
                    //Сохраняем только первый запрос,
                    this.setCache(responseWithTimestamp);
                }
                return responseWithTimestamp;
            };

            this.lastCallTime = Date.now();
            return buildResponse(data);
        } catch (error) {
            console.error("Error fetching best tokens:", error);
            return {
                cursor: null,
                items: [],
                updatedAt: Date.now(),
            };
        }
    }

    private static getCachedData(): IDyorBestTokensResponse | null {
        const cached = localStorage.getItem(this.cacheKey);
        if (cached) {
            try {
                const data = JSON.parse(cached);
                if (data.updatedAt && data.items && Array.isArray(data.items)) {
                    return data;
                }
            } catch (error) {
                console.error("Invalid cache data", error);
                return null;
            }
        }
        return null;
    }

    private static setCache(data: IDyorBestTokensResponse): void {
        localStorage.setItem(this.cacheKey, JSON.stringify(data));
    }
    private static clearCache(): void {
        localStorage.removeItem(this.cacheKey);
    }
}
